export const environment = {
    production: false,
    apiUrl: 'https://sequencing-dev.transnetyx.com',

    auth0: {
        domain: 'login-dev.transnetyx.com',
        clientId: 'cZh8HC8AnvYiJU1AkLaKq7PeASNCbFEr',
        redirectUri: `${window.location.origin}`,
        logoutReturnUrl: `https://accounts-dev.transnetyx.com/v2/logout/sequencing`,
        logoutUrl: 'https://login-dev.transnetyx.com/v2/logout',
    },

    analytics: {
        enable: true,
        mixpanelCode: '52c907384e375a34d8eab040c987820f',
    },

    colonyUrl: 'https://colony-dev.transnetyx.com/',
    automatedGenotypingUrl: 'https://quickorder-dev.transnetyx.com/Default.aspx',
    geneticMonitoringUrl: 'https://quickorder-dev.transnetyx.com/GeneticMonitoring/home',
    microbiomeUrl: 'https://quickorder-dev.transnetyx.com/MVC/Microbiome/home',
    quickorderUrl: 'https://quickorder-dev.transnetyx.com/MVC/Account/Register',
    quickorderSettingsUrl: 'https://quickorder-dev.transnetyx.com/Account.aspx',
    quickorderPaymentSettingsUrl: 'https://quickorder-dev.transnetyx.com/PaymentMethods.aspx',
    quickorderMessagesUrl: 'https://quickorder-dev.transnetyx.com/Messages.aspx',
    ordersUrl: 'https://quickorder-dev.transnetyx.com/Orders.aspx',
    newOrdersUrl: 'https://quickorder-dev.transnetyx.com/Order1.StrainSelection.aspx',
    geneticMonitoringOrdersUrl: 'https://quickorder-dev.transnetyx.com/MVC/GeneticMonitoring/Orders',
    microbiomeOrdersUrl: 'https://quickorder-dev.transnetyx.com/MVC/Microbiome',
    accountSettingsUrl: 'https://accounts-dev.transnetyx.com/Account/Details',
    accountRegisterUrl: 'https://accounts-dev.transnetyx.com/register/quick-order',

    billingSettingsUrl: 'https://quickorder-dev.transnetyx.com/PaymentMethods.aspx',
    messageSettingsUrl: 'https://quickorder-dev.transnetyx.com/EmailPreferences.aspx',
    tissueUrl: 'https://tissue.transnetyx.com/',
    checkMateUrl: 'https://checkmate-dev.transnetyx.com/',
    registerUrl: 'https://login-dev.transnetyx.com/authorize',
};
